export default __webpack_public_path__ + "media/zurb/img/events/wired/dst/dst-image2-3d6664fce8f1bca254b683358a9981be.png";